import { defineStore } from "pinia";

export const useGraphlyTemplatesStore = defineStore("GraphlyTemplatesStore", () => {
	const dataobjectShape = "https://cdn.graphly.dev/@livereader/dataobject/latest";
	const demoHexagonShape = "https://cdn.graphly.dev/@jason-rietzke/demo-hexagon/latest";
	const annotationShape = "https://cdn.graphly.dev/@livereader/annotation/latest";

	return {
		dataobjectShape,
		demoHexagonShape,
		annotationShape,
	};
});
